/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Avatar, Button, message, Modal, Spin, Table } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";

import { getSupaClient } from "../../lib/supabase";
import { SlackEditorPreview } from "../TextEditor/SlackEditor";

const DATE_FORMAT = "MMM D h:mm a";
const teamId = localStorage.getItem("team-id");

/**
 * Show table to track a specific trigger
 * @props selectedTrigger Trigger Object
 * @props selectTrigger Callback function that is fired when the user navigates back to the existing
 * triggers page
 */
const TrackTrigger = (props) => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [isTriggerEditVisible, setIsTriggerEditVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedUser, setSelectedUser] = useState({
    name: "",
  });

  useEffect(async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("trigger_invocations")
      .select(
        "id, target_user (slack_id, name, image_32), scheduled_tasks (id, team, status, scheduled_time_utc, step_number, payload)"
      )
      .eq("team", teamId)
      .eq("team_trigger", props.selectedTrigger.id)
      .order("id", { ascending: false });

    if (error) {
      message.error("Try again");
    }
    if (data) {
      const list = data.map((item) => {
        return {
          name: item.target_user?.name,
          key: item.id,
          image_32: item.target_user?.image_32,
          messages: item.scheduled_tasks.filter(
            (task) => task.status === "completed"
          ).length,
          scheduled_tasks: item.scheduled_tasks.map((s) => {
            return {
              step: s.step_number + 1,
              status: s.status,
              time: moment(s.scheduled_time_utc).format(DATE_FORMAT),
              message: s.payload.messages[0],
            };
          }),
          last_message:
            item.scheduled_tasks.length > 0
              ? item.scheduled_tasks.filter(
                  (task) => task.status === "completed"
                ).length > 0
                ? moment(
                    item.scheduled_tasks
                      .filter((task) => task.status === "completed")
                      .slice()
                      .pop().scheduled_time_utc
                  ).format(DATE_FORMAT)
                : "--"
              : "--",
          next_message:
            item.scheduled_tasks.length > 0
              ? item.scheduled_tasks.filter(
                  (task) => task.status !== "completed"
                ).length > 0
                ? moment(
                    item.scheduled_tasks.filter(
                      (task) => task.status !== "completed"
                    )[0].scheduled_time_utc
                  ).format(DATE_FORMAT)
                : "--"
              : "--",
          status:
            item.scheduled_tasks.length > 0
              ? item.scheduled_tasks[item.scheduled_tasks.length - 1].status
              : "--",
        };
      });
      setDataSource(list);
    }
    setLoading(false);
  }, [props.selectedTrigger]);

  const closeEditModal = () => {
    setIsTriggerEditVisible(false);
  };

  const userColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
      render: (name, record) => (
        <>
          <Avatar src={record.image_32} style={{ marginRight: 15 }} />
          <Button
            type="link"
            key={record.id}
            onClick={() => {
              setIsTriggerEditVisible(true);
              setSelectedUser(record);
            }}
          >
            {name}
          </Button>
        </>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Messages sent",
      dataIndex: "messages",
      key: "messages",
      sorter: (a, b) => a.age - b.age,
    },
    {
      title: "Last message sent",
      key: "last_message",
      dataIndex: "last_message",
      sorter: (a, b) => moment(a.last_message) - moment(b.last_message),
    },
    {
      title: "Next message sends at",
      key: "next_message",
      sorter: (a, b) => moment(a.next_message) - moment(b.next_message),
      render: (user) => (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>{user.next_message}</div>
          <Button
            type="link"
            key={user.id}
            onClick={() => {
              setIsTriggerEditVisible(true);
              setSelectedUser(user);
            }}
          >
            View messages
          </Button>
        </div>
      ),
    },
  ];

  const messageColumns = [
    {
      title: "Step",
      dataIndex: "step",
      key: "step",
      render: (name) => name,
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (msg) => <SlackEditorPreview message={msg} />,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
  ];

  return (
    <>
      <Spin spinning={loading}>
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <Button type="link" onClick={() => props.selectTrigger(null)}>
            Back
          </Button>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ fontSize: 16, textDecoration: "blod" }}>
            Track - {props.selectedTrigger.name}
          </p>
          <div>Created by: {props.selectedTrigger.created_by}</div>
        </div>
        <Table columns={userColumns} dataSource={dataSource} />

        <Modal
          width={1100}
          title={selectedUser?.name}
          visible={isTriggerEditVisible}
          onCancel={closeEditModal}
          footer={[]}
        >
          <Table
            columns={messageColumns}
            dataSource={selectedUser.scheduled_tasks}
          />
        </Modal>
      </Spin>
    </>
  );
};

export default TrackTrigger;
